const sessionInitialState = {
    version: 5,
    loading: false,
    loggedIn: false,
    credentials: {
        user: null,
        menu_permissions: [],
        route_permissions: [],
        action_permissions: [],
        token: null
    },
    login: {
        processing: false,
        failed: false,
        error: {}
    },
    logout: {
        processing: false,
        failed: false,
        error: {}
    },
    register: {
        processing: false,
        failed: false,
        error: {}
    },
    updateData: {
        processing: false,
        failed: false,
        error: {}
    }
};

const menuInitialState = {
    openItem: ['dashboard'],
    openComponent: 'buttons',
    drawerOpen: false,
    componentDrawerOpen: true,
    filter: {
        enabled: false,
        opened: false
    }
};

const dashboardInitialState = {
    loading: false,
    stores: {
        loading: false,
        data: null,
        active_only: [],
        error: null
    },
    suppliers: {
        loading: false,
        data: null,
        error: null
    },
    productClasses: {
        loading: false,
        data: null,
        error: null
    },
    brands: {
        loading: false,
        data: null,
        error: null
    },
    salesStats: {
        loading: false,
        data: null,
        error: null
    },
    loadAccountPayableChart: {
        loading: false,
        data: null,
        error: null
    },
    bestSellers: {
        loading: false,
        data: null,
        error: null
    },
    filters: {
        store: [],
        supplier: []
    },
    categories: {
        loading: false,
        data: null,
        error: null
    }
};

const optionsInitialState = {
    accountPayableShowOverdue: true
};

export { sessionInitialState, menuInitialState, dashboardInitialState, optionsInitialState };

export default {
    session: sessionInitialState,
    menu: menuInitialState,
    dashboard: dashboardInitialState,
    options: optionsInitialState
};
